const L = {
  name: "UpDown",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16 18.5859L13 15.5859L11.5858 17.0001L17 22.4143L22.4142 17.0001L21 15.5859L18 18.5859V8.00009H16L16 18.5859Z" fill="currentColor"/>
<path d="M8.00015 5.41436L11.0002 8.41436L12.4144 7.00015L7.00015 1.58594L1.58594 7.00015L3.00015 8.41436L6.00015 5.41436L6.00015 16.0002H8.00015L8.00015 5.41436Z" fill="currentColor"/>
</svg>
  `
};
export {
  L as UpDown
};
